import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';

@Component({
    selector: 'tt-activities-grid',
    templateUrl: './activities-grid.component.html',
    styleUrls: ['./activities-grid.component.css'],
})
export class ActivitiesGridComponent implements OnChanges {
    @Input()
    public rememberId: string = 'w_activitygrid.grid';

    @Input()
    public params?: ActivitiesGridParams;

    @Output()
    public gridReady = new EventEmitter<GridOptions>();

    public grid?: GridOptions;

    public readGrid() {
        if (!this.params) {
            console.warn('Projects grid needs parameters');
            return;
        }

        if (!this.grid) {
            this.grid = new Grid().setRememberId(this.rememberId).setLoadDataFunction({ method: 2452, parameters: () => this.params });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            if (this.validActivitiesGridParams(changes['params'].currentValue)) {
                this.readGrid();
            } else {
                console.error('Invalid activitygrid grid parameters');
                console.dir(changes['params'].currentValue);
            }
        }
    }

    private validActivitiesGridParams(params: unknown): params is ActivitiesGridParams {
        return !!params && typeof params === 'object';
    }
}

export interface ActivitiesGridParams {
    /**
     * @default '0'
     */
    cust_no?: string | number;

    /**
     * @default '' current businessco
     */
    businessco_no?: string | number;

    /**
     * @default '-'
     */
    argtype?: string;

    /**
     * @default 1000
     */
    topnumber?: string | number;

    /**
     * @default ''
     */
    searchtext?: string;

    /**
     * @default 'SEARCH'
     */
    bg_main?: string;

    /**
     * @default '-'
     */
    filterfield?: string;

    /**
     * @default '-'
     */
    filtervalue?: string;

    /**
     * @default '0'
     */
    ok?: '1' | '0' | 'A';

    /**
     * @default 'A'
     */
    custacttype?: string;

    /**
     * @default 0
     */
    actstatus_keyno?: string | number;
}
